import __var_0__ from '@stdlib/assert/is-plain-object';
import __var_1__ from '@stdlib/assert/is-function';
import __var_2__ from '@stdlib/assert/is-array';
import __var_3__ from '@stdlib/assert/is-typed-array';
import __var_4__ from '@stdlib/assert/is-positive-integer';
import __var_5__ from '@stdlib/assert/has-own-property';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isObject = __var_0__;
var isFunction = __var_1__;
var isArray = __var_2__;
var isTypedArray = __var_3__;
var isPositiveInteger = __var_4__.isPrimitive;
var hasOwnProp = __var_5__;


// MAIN //

/**
* Validates function options.
*
* @private
* @param {Options} opts - function options
* @param {(Array|TypedArray)} [opts.x] - chart data
* @param {(Array|TypedArray)} [opts.y] - chart data
* @param {Function} [opts.xValue] - x-value accessor
* @param {Function} [opts.yValue] - y-value accessor
* @param {PositiveInteger} leafDigits - number of digits to display as leafs
* @returns {(Error|null)} error or null
*
* @example
* var opts = {
*     'x': [ 23, 11, 137, 58 ],
*     'y': [ 21, 11, 39, 80 ]
* };
* var err = validate( opts );
* if ( err ) {
*     throw err;
* }
*/
function validate( opts ) {
	if ( !isObject( opts ) ) {
		return new TypeError( 'invalid argument. Options argument must be an object. Value: `' + opts + '`.' );
	}
	if ( hasOwnProp( opts, 'x' ) ) {
		if ( !isArray( opts.x ) && !isTypedArray( opts.x ) ) {
			return new TypeError( 'invalid option. `x` option must be an array or typed array. Option: `' + opts.x + '`.' );
		}
	}
	if ( hasOwnProp( opts, 'xValue' ) ) {
		if ( !isFunction( opts.xValue ) ) {
			return new TypeError( 'invalid option. `xValue` option must be a function. Option: `' + opts.xValue + '`.' );
		}
	}
	if ( hasOwnProp( opts, 'y' ) ) {
		if ( !isArray( opts.y ) && !isTypedArray( opts.y ) ) {
			return new TypeError( 'invalid option. `y` option must be an array or typed array. Option: `' + opts.y + '`.' );
		}
	}
	if ( hasOwnProp( opts, 'yValue' ) ) {
		if ( !isFunction( opts.yValue ) ) {
			return new TypeError( 'invalid option. `yValue` option must be a function. Option: `' + opts.yValue + '`.' );
		}
	}
	if ( hasOwnProp( opts, 'leafDigits' ) ) {
		if ( !isPositiveInteger( opts.leafDigits ) ) {
			return new TypeError( 'invalid option. `leafDigits` option must be a positive integer. Option: `' + opts.leafDigits + '`.' );
		}
	}
	return null;
}


// EXPORTS //
export default validate;
